import {
  Allergy,
  useAddAllergyMutation,
  useAllergiesQuery,
  useCurrentPatientId,
  useDefaultQueryOptions,
  useDeleteAllergyMutation,
  useReplaceAllergiesMutation
} from '@/modules/surgicalEvent';

export const useCurrentAllergies = () =>
  useAllergiesQuery(useCurrentPatientId(), useDefaultQueryOptions());

export const useCurrentAddAllergy = () => {
  const currentParams = useCurrentPatientId();
  const [addAllergy, ...mutationProps] = useAddAllergyMutation();

  async function handleAddAllergy(allergy: Partial<Allergy>) {
    return addAllergy({ ...currentParams, allergy }).unwrap();
  }

  return [handleAddAllergy, ...mutationProps] as const;
};

export const useCurrentReplaceAllergies = () => {
  const currentParams = useCurrentPatientId();
  const [replaceAllergies, ...mutationProps] = useReplaceAllergiesMutation();

  async function handleReplaceAllergies(allergies: Partial<Allergy>[]) {
    return replaceAllergies({ ...currentParams, allergies });
  }

  return [handleReplaceAllergies, ...mutationProps] as const;
};

export const useCurrentDeleteAllergy = () => {
  const currentParams = useCurrentPatientId();
  const [deleteAllergy, ...mutationProps] = useDeleteAllergyMutation();

  async function handleDeleteAllergy(allergyId: string) {
    return deleteAllergy({ ...currentParams, allergyId });
  }

  return [handleDeleteAllergy, ...mutationProps] as const;
};
